export default "__VITE_ASSET__DDRMwoSG__"